<form [formGroup]="outreachEmailForm">
  <div class="flex flex-col gap-2 flex-1">
    <div class="flex flex-row gap-2">
      <mat-form-field class="flex-1">
        <mat-label data-test-id="outreach-email-content-form-currency-label">Currency</mat-label>
        <mat-select formControlName="currency" data-test-id="outreach-email-content-form-currency-input">
          @for (currency of currencies; track currency) {
            <mat-option data-test-id="outreach-email-content-form-currency-option" [value]="currency">
              {{ currency }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label data-test-id="outreach-email-content-form-honorarium-label">Honorarium</mat-label>
        <input
          matInput
          type="number"
          formControlName="honorarium"
          min="0"
          data-test-id="outreach-email-content-form-honorarium-input"
        />
        <mat-error data-test-id="outreach-email-content-form-honorarium-error">Must be at least 0</mat-error>
      </mat-form-field>
    </div>

    <div formGroupName="sendConfig" class="flex flex-row gap-2">
      <mat-form-field class="flex-1">
        <mat-label data-test-id="outreach-email-content-form-send-date-label">Send date</mat-label>
        <input
          matInput
          type="date"
          formControlName="sendDate"
          data-test-id="outreach-email-content-form-send-date-input"
          [min]="minStartDate"
        />
        <mat-error data-test-id="outreach-email-content-form-send-date-error">{{ getError() }}</mat-error>
        @if (weekendWarning) {
          <mat-hint data-test-id="outreach-email-content-form-send-date-help-text"> Is weekend </mat-hint>
        }
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label data-test-id="outreach-email-content-form-send-time-label">Send time</mat-label>
        <input
          matInput
          type="time"
          formControlName="sendTime"
          data-test-id="outreach-email-content-form-send-time-input"
        />
      </mat-form-field>
    </div>

    <app-outreach-template-select [templates]="(templatesFiltered$ | async) ?? []" />

    @if (isConnectTemplate()) {
      <app-outreach-template-content-form groupName="templateContent"> </app-outreach-template-content-form>
    }
  </div>
</form>

<ng-template #templateOption let-template="template">
  <div class="flex flex-row gap-3">
    <p>
      {{ template.name }}
    </p>
    <div class="flex flex-row gap-1 flex-wrap" [matTooltip]="template.tagTooltipText">
      @for (tag of template.displayTags; track tag) {
        <span class="bg-[#228cdb] rounded-[0.25rem] py-1 px-2 text-xs text-white font-bold">
          {{ tag }}
        </span>
      }
    </div>
  </div>
</ng-template>
